<template>
  <b-row>
    <b-col>
      <template v-if="routeName === 'EXSBDocumentCreate'">
        <b-row>
          <b-col>
            <router-link :to="{ name: 'EXSBDocumentList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="card">
              <div class="card-body">
                <b-row>
                  <b-col>
                    <EXSBDocumentForm
                            :handle-submit="onSendForm"
                            :handle-update-field="updateField"
                            :values="item"
                            :errors="violations" />
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <EXSBDocumentForm
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :ordersDocument="ordersDocument"
                :errors="violations" />
      </template>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXSBDocumentForm from './Form'
import moment from 'moment'
import { checkPagePermission } from '@/utils/checkRoles.js'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'

const { mapGetters, mapActions } = createNamespacedHelpers('exsbdocument/create')

export default {
  components: {
    EXSBDocumentForm
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBDocumentCreate')
  },

  props: {
    order: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      moment,
      positions: [],
      ordersDocument: false,
      routeName: null,
      item: {
        dateOfIssue: this.$moment().format('YYYY-MM-DD'),
        delivery: null,
        warehouse: null,
        positions: [],
        documentType: null,
        batchNumber: null,
        exhibitorNip: '',
        exhibitor: '',
        exhibitorStreet: '',
        exhibitorCity: '',
        exhibitorPostcode: '',
        receiverNip: '',
        receiver: '',
        receiverStreet: '',
        receiverCity: '',
        receiverPostcode: ''
      }
    }
  },

  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'EXSBDocumentShow', params: { id: created['@id'] } })
    }
  },

  created () {
    this.routeName = this.$route.name
    this.checkOrderProps()
  },

  methods: {
    ...mapActions([
      'create'
    ]),
    // handle incoming data, can be order or invoice
    checkOrderProps () {
      if (this.order) {
        // id
        this.ordersDocument = true
        if (this.order['@id']) {
          this.item.idOrder = this.order['@id']
        } else if (this.order.idInvoice) {
          this.item.idInvoice = this.order.idInvoice
        }
        // positions
        if (this.order.positions && this.order.positions.length > 0) {
          this.positions = this.order.positions.map(position => {
            return {
              item: position.item['@id'],
              vatRate: position.vatRate['@id'] || null,
              measure: position.measure['@id'] || null,
              pricePerUnitBrutto: position.pricePerUnitBrutto ? position.pricePerUnitBrutto.toString() : position.priceBruttoPerUnit.toString(),
              pricePerUnitNetto: position.pricePerUnitNetto ? position.pricePerUnitNetto.toString() : position.priceNettoPerUnit.toString(),
              quantity: parseFloat(position.quantity),
              discount: position.discount ? position.discount.toString() : null,
              valueNetto: position.valueNetto.toString(),
              valueBrutto: position.valueBrutto.toString()
            }
          })
        }
        this.item.positions = this.positions
        // documentType
        if (!this.order.idInvoice) {
          this.item.documentType = '/core/public/index.php/api/e_x_s_b_document_types/1'
        } else if (this.order.idInvoice) {
          if (this.order.invoiceDocumentType === 2) {
            this.item.documentType = '/core/public/index.php/api/e_x_s_b_document_types/2'
          } else if (this.order.invoiceDocumentType === 1) {
            this.item.documentType = '/core/public/index.php/api/e_x_s_b_document_types/1'
          }
        }
        this.getFirmData()
      }
    },

    async getFirmData () {
      const response = await new ApiService(`user_datas/${getId(this.order.firm['@id'])}`).getResults()
      if (response) {
        this.item.receiver = response.firmname1 || response.fullName
        this.item.receiverNip = response.nip
        this.item.receiverStreet = response.street
        this.item.receiverCity = response.city
        this.item.receiverPostcode = response.postcode
      }
    },

    onSendForm () {
      let item = Object.assign({}, this.item)
      if (item.dateOfIssue === '') {
        item.dateOfIssue = undefined
      } else {
        item.dateOfIssue = this.moment(item.dateOfIssue).format('YYYY-MM-DD')
      }
      if (item.protocolPeriodStart === '') {
        item.protocolPeriodStart = undefined
      } else {
        item.protocolPeriodStart = this.moment(item.dateOfIssue).format('YYYY-MM-DD')
      }
      if (item.protocolPeriodEnd === '') {
        item.protocolPeriodEnd = undefined
      } else {
        item.protocolPeriodEnd = this.moment(item.dateOfIssue).format('YYYY-MM-DD')
      }
      item.positions.forEach(position => {
        position.quantity = parseFloat(position.quantity)
      })
      item.valueNetto = 0
      item.valueBrutto = 0
      item.valueBrutto = item.valueBrutto.toString()
      item.valueNetto = item.valueNetto.toString()
      this.create(item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
